/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc
 */
import * as References from './HubSpotVideoRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByVideoId
 */
export const GET_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByVideoId';
export const GET_VIDEO_BY_VIDEO_ID_QUERY: RegisteredQuery<
  'result',
  References.GetVideoByVideoIdRequestType,
  References.GetVideoByVideoIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME,
  args: ['videoId'],
  fetcher(
    request: References.GetVideoByVideoIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideoByVideoIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideoByVideoIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getCrmVideoByVideoId
 */
export const GET_CRM_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getCrmVideoByVideoId';
export const GET_CRM_VIDEO_BY_VIDEO_ID_QUERY: RegisteredQuery<
  'result',
  References.GetCrmVideoByVideoIdRequestType,
  References.GetCrmVideoByVideoIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_CRM_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME,
  args: ['videoId'],
  fetcher(
    request: References.GetCrmVideoByVideoIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetCrmVideoByVideoIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getCrmVideoByVideoIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideosByVideoIds
 */
export const GET_VIDEOS_BY_VIDEO_IDS_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideosByVideoIds';
export const GET_VIDEOS_BY_VIDEO_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetVideosByVideoIdsRequestType,
  References.GetVideosByVideoIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEOS_BY_VIDEO_IDS_QUERY_FIELD_NAME,
  args: ['videoIds'],
  fetcher(
    request: References.GetVideosByVideoIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideosByVideoIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideosByVideoIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByFileId
 */
export const GET_VIDEO_BY_FILE_ID_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByFileId';
export const GET_VIDEO_BY_FILE_ID_QUERY: RegisteredQuery<
  'result',
  References.GetVideoByFileIdRequestType,
  References.GetVideoByFileIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEO_BY_FILE_ID_QUERY_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(
    request: References.GetVideoByFileIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideoByFileIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideoByFileIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideosByFileIdsBulk
 */
export const GET_VIDEOS_BY_FILE_IDS_BULK_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideosByFileIdsBulk';
export const GET_VIDEOS_BY_FILE_IDS_BULK_QUERY: RegisteredQuery<
  'result',
  References.GetVideosByFileIdsBulkRequestType,
  References.GetVideosByFileIdsBulkResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEOS_BY_FILE_IDS_BULK_QUERY_FIELD_NAME,
  args: ['sourceFileIds'],
  fetcher(
    request: References.GetVideosByFileIdsBulkRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideosByFileIdsBulkResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideosByFileIdsBulkRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByCrmId
 */
export const GET_VIDEO_BY_CRM_ID_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByCrmId';
export const GET_VIDEO_BY_CRM_ID_QUERY: RegisteredQuery<
  'result',
  References.GetVideoByCrmIdRequestType,
  References.GetVideoByCrmIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEO_BY_CRM_ID_QUERY_FIELD_NAME,
  args: ['crmObjectId'],
  fetcher(
    request: References.GetVideoByCrmIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideoByCrmIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideoByCrmIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#softDeleteVideoByFileId
 */
export const SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_softDeleteVideoByFileId';
export const SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION: RegisteredQuery<
  'result',
  References.SoftDeleteVideoByFileIdRequestType,
  References.SoftDeleteVideoByFileIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(
    request: References.SoftDeleteVideoByFileIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SoftDeleteVideoByFileIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.softDeleteVideoByFileIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#softDeleteVideosByFileIdsBulk
 */
export const SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_softDeleteVideosByFileIdsBulk';
export const SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION: RegisteredQuery<
  'result',
  References.SoftDeleteVideosByFileIdsBulkRequestType,
  References.SoftDeleteVideosByFileIdsBulkResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION_FIELD_NAME,
  args: ['sourceFileIds'],
  fetcher(
    request: References.SoftDeleteVideosByFileIdsBulkRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SoftDeleteVideosByFileIdsBulkResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.softDeleteVideosByFileIdsBulkRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#hardDeleteVideoByFileId
 */
export const HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_hardDeleteVideoByFileId';
export const HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION: RegisteredQuery<
  'result',
  References.HardDeleteVideoByFileIdRequestType,
  References.HardDeleteVideoByFileIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(
    request: References.HardDeleteVideoByFileIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.HardDeleteVideoByFileIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.hardDeleteVideoByFileIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoByFileId
 */
export const UPDATE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoByFileId';
export const UPDATE_VIDEO_BY_FILE_ID_MUTATION: RegisteredQuery<
  'result',
  References.UpdateVideoByFileIdRequestType,
  References.UpdateVideoByFileIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: [
    'fileId',
    'fileName',
    'seoTitle',
    'description',
    'tags',
    'thumbnailSourceFileId',
    'thumbnailSourceMilliseconds',
    'isEmbeddable',
    'chapters',
    'videoAttributes',
    'posterUrl',
    'changeSource',
    'clearChapters',
  ],
  fetcher(
    request: References.UpdateVideoByFileIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateVideoByFileIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateVideoByFileIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#setThumbnail
 */
export const SET_THUMBNAIL_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_setThumbnail';
export const SET_THUMBNAIL_MUTATION: RegisteredQuery<
  'result',
  References.SetThumbnailRequestType,
  References.SetThumbnailResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_THUMBNAIL_MUTATION_FIELD_NAME,
  args: ['fileId', 'thumbnailFileId', 'thumbnailTimestampMillis'],
  fetcher(
    request: References.SetThumbnailRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetThumbnailResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.setThumbnailRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoEmbeddability
 */
export const UPDATE_VIDEO_EMBEDDABILITY_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoEmbeddability';
export const UPDATE_VIDEO_EMBEDDABILITY_MUTATION: RegisteredQuery<
  'result',
  References.UpdateVideoEmbeddabilityRequestType,
  References.UpdateVideoEmbeddabilityResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_VIDEO_EMBEDDABILITY_MUTATION_FIELD_NAME,
  args: ['isEmbeddable', 'sourceFileId'],
  fetcher(
    request: References.UpdateVideoEmbeddabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateVideoEmbeddabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateVideoEmbeddabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoVisibility
 */
export const UPDATE_VIDEO_VISIBILITY_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoVisibility';
export const UPDATE_VIDEO_VISIBILITY_MUTATION: RegisteredQuery<
  'result',
  References.UpdateVideoVisibilityRequestType,
  References.UpdateVideoVisibilityResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_VIDEO_VISIBILITY_MUTATION_FIELD_NAME,
  args: ['visibility', 'sourceFileId'],
  fetcher(
    request: References.UpdateVideoVisibilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateVideoVisibilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateVideoVisibilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoLimitInfo
 */
export const GET_VIDEO_LIMIT_INFO_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoLimitInfo';
export const GET_VIDEO_LIMIT_INFO_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetVideoLimitInfoResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEO_LIMIT_INFO_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideoLimitInfoResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideoLimitInfoRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoLimitInfoForDisplay
 */
export const GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoLimitInfoForDisplay';
export const GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetVideoLimitInfoForDisplayResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetVideoLimitInfoForDisplayResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getVideoLimitInfoForDisplayRpc,
      { timeout: ctx.timeout }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getOrCreateShareKey
 */
export const GET_OR_CREATE_SHARE_KEY_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getOrCreateShareKey';
export const GET_OR_CREATE_SHARE_KEY_MUTATION: RegisteredQuery<
  'result',
  References.GetOrCreateShareKeyRequestType,
  References.GetOrCreateShareKeyResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: GET_OR_CREATE_SHARE_KEY_MUTATION_FIELD_NAME,
  args: ['fileId'],
  fetcher(
    request: References.GetOrCreateShareKeyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetOrCreateShareKeyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getOrCreateShareKeyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#resolveShareKey
 */
export const RESOLVE_SHARE_KEY_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_resolveShareKey';
export const RESOLVE_SHARE_KEY_QUERY: RegisteredQuery<
  'result',
  References.ResolveShareKeyRequestType,
  References.ResolveShareKeyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RESOLVE_SHARE_KEY_QUERY_FIELD_NAME,
  args: ['shareKey'],
  fetcher(
    request: References.ResolveShareKeyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ResolveShareKeyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.resolveShareKeyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getSignedTranscripts
 */
export const GET_SIGNED_TRANSCRIPTS_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getSignedTranscripts';
export const GET_SIGNED_TRANSCRIPTS_QUERY: RegisteredQuery<
  'result',
  References.GetSignedTranscriptsRequestType,
  References.GetSignedTranscriptsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SIGNED_TRANSCRIPTS_QUERY_FIELD_NAME,
  args: ['videoId', 'languages'],
  fetcher(
    request: References.GetSignedTranscriptsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSignedTranscriptsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSignedTranscriptsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getPreviewPlayer
 */
export const GET_PREVIEW_PLAYER_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoRpc_getPreviewPlayer';
export const GET_PREVIEW_PLAYER_QUERY: RegisteredQuery<
  'result',
  References.GetPreviewPlayerRequestType,
  References.GetPreviewPlayerResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PREVIEW_PLAYER_QUERY_FIELD_NAME,
  args: ['videoId', 'parentDomain'],
  fetcher(
    request: References.GetPreviewPlayerRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPreviewPlayerResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPreviewPlayerRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
